// Upload a file straight to Vercel Blob from the browser (no function body-size
// limit), via the /api/blob-upload token endpoint. Returns the public URL.
import { upload } from '@vercel/blob/client';
import apiConfig from '../../../config/api';

const BASE = apiConfig.apiBaseUrl || '';

// onProgress (optional) receives 0-100 while the browser streams the file up —
// callers surface it so an upload never looks identical to a stall (graphic-log §1.2).
export async function uploadFile(file, { onProgress } = {}) {
  const blob = await upload(file.name, file, {
    access: 'public',
    handleUploadUrl: `${BASE}/api/blob-upload`,
    ...(onProgress ? { onUploadProgress: ({ percentage }) => onProgress(percentage) } : {}),
  });
  return blob.url;
}
